var exports = {
  "lm": "XzZZaVY",
  "HT": "RGphVUs",
  "Fi": "OVp3Y1N",
  "fY": "ZENLaTk",
  "q": "UVhGTEp",
  "xC": "VDQ5X3d",
  "Hh": "YWY4aWR",
  "WQ": "LW14YXZ",
};

module.exports = exports;
